import React, { useContext, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { AuthContext } from 'contexts/AuthContext';
import { DropsContext } from 'contexts/DropsContext';
import { VendaContext } from 'contexts/VendaContext';
import { RelatoriosContext } from 'contexts/RelatoriosContext';
import { NotificaçõesContext } from 'contexts/NotificaçõesContext';
import { useDialog } from 'components/Modals';
import RelatorioModal from 'components/Modals/RelatorioModal';
import Navbar from 'components/Navbar';
import Routes from 'routes';

const styles = {
  main: {
    height: '100vh',
  },
  container: {
    padding: '88px 24px 0 24px',
  },
};

const App = () => {
  const { user } = useContext(AuthContext);
  const { getDrops } = useContext(DropsContext);
  const { getContas } = useContext(VendaContext);
  const { relatorio } = useContext(RelatoriosContext);
  const { getNotifications } = useContext(NotificaçõesContext);
  const { openDialog } = useDialog();

  useEffect(() => {
    getContas();
    getNotifications();
    getDrops([
      'Aplicacao',
      'Ccusto',
      'Cfiscal',
      'Cfo',
      'Cidade',
      'CondicaoPagamento',
      'Contribuinte',
      'CrmFunil',
      'CrmMotivoDescarte',
      'Cxconta',
      'Documento',
      'Entidade',
      'EntidadeEndereco',
      'EntidadeTipo',
      'EspecieDocumento',
      'EtiquetaModelo',
      'Filial',
      'FormaDeEnvio',
      'FormaDePagamento',
      'Frota',
      'GrupoProduto',
      'Impressoraweb',
      'IndicadoresAtividade',
      'IndicadoresIndicacao',
      'IndicadoresNegocio',
      'IndicadoresRegiao',
      'IndicadoresTipo',
      'IntegraAccess',
      'IntegraLoja',
      'LinhaProduto',
      'LocalEstoque',
      'Logo',
      'Marca',
      'ModalidadeBc',
      'Moeda',
      'NaturezaOperacao',
      'OrigemTributaria',
      'Planoconta',
      'Produto',
      'ProdutoServico',
      'ProdutoVariacao',
      'RegiaoEntidade',
      'Serie',
      'ServicoIndop',
      'SituacaoTributaria',
      'SituacaoTributariaClassificacao',
      'StatusDocumento',
      'TabelaPreco',
      'Tributo',
      'UF',
      'UnidadeMedida',
      'Users',
    ]);
  }, []);

  useEffect(() => {
    if (relatorio) {
      openDialog(<RelatorioModal relatorio={relatorio} />, relatorio?.nome);
    }
  }, [relatorio]);

  return (
    <div style={styles.main}>
      <Navbar />
      <Scrollbars>
        <div style={styles.container}>
          <Routes user={user} />
        </div>
      </Scrollbars>
    </div>
  );
};

export default App;
